export default "__VITE_ASSET__DHd807KO__"